module.exports = __webpack_public_path__ + "img/logo_csuglobal.f5b71017.png";